// This is the File where we store menu items and their routes and classnames, the menus are imported
// inside Navbar.js

// The main menu (all items)

// here are the property names and their meanings
// Name: the name of the menu item displayed for the user
// Route: the page it leads the user to
// IsExact: for react-router to mathc the url exactly (useful for index route which is '/')
// ClassName: default class name of the element
// IsLastItem: for displaying the line for seperating sectons under the navigation item
// Nodes: submenus of the Navigation section
// ActiveClassName: for applying active state to a navigation item (provided by react-router)

export const Menu = [
  {
    Name: "Dashboard",
    Route: "/",
    IsExact: true,
    ClassName: "nav-parent",
    IsLastItem: false,
    MobileIcon: "DashboardMobile",
    Nodes: [
      {
        Name: "Dashboard 1",
        Route: "/Sub1",
      },
      {
        Name: "Dashboard 2",
        Route: "/Sub2",
      },
    ],
  },
  {
    Name: "Talent",
    Route: "/talent",
    IsExact: false,
    ClassName: "nav-parent",
    IsLastItem: false,
    MobileIcon: "TalentMobile",
    Nodes: [
      {
        Name: "Candidats",
        Route: "/candidats",
      },
      {
        Name: "Successors",
        Route: "/successors",
      },
      {
        Name: "Mentors, Coaches",
        Route: "/MentorsCoaches",
      },
    ],
  },
  {
    Name: "Positions",
    Route: "/positions",
    IsExact: false,
    ClassName: "nav-parent",
    IsLastItem: false,
    MobileIcon: "PositionsMobile",
    Nodes: [
      {
        Name: "Submenu 1",
        Route: "/Sub1",
      },
      {
        Name: "Submenu 2",
        Route: "/Sub2",
      },
    ],
  },
  {
    Name: "Organization",
    Route: "/organization",
    IsExact: false,
    ClassName: "nav-parent",
    IsLastItem: true,
    MobileIcon: "OrganizationMobile",
    Nodes: [
      {
        Name: "Submenu 1",
        Route: "/Sub1",
      },
      {
        Name: "Submenu 2",
        Route: "/Sub2",
      },
    ],
  },
  {
    Name: "Jobs",
    Route: "/jobs",
    IsExact: false,
    ClassName: "nav-parent",
    IsLastItem: false,
    MobileIcon: "JobsMobile",
    Nodes: [
      {
        Name: "Submenu 1",
        Route: "/Sub1",
      },
      {
        Name: "Submenu 2",
        Route: "/Sub2",
      },
    ],
  },
  {
    Name: "Projects",
    Route: "/projects",
    IsExact: false,
    ClassName: "nav-parent",
    IsLastItem: false,
    MobileIcon: "ProjectsMobile",
    Nodes: [
      {
        Name: "Submenu 1",
        Route: "/Sub1",
      },
      {
        Name: "Submenu 2",
        Route: "/Sub2",
      },
    ],
  },
  {
    Name: "Activities",
    Route: "/activities",
    IsExact: false,
    ClassName: "nav-parent",
    IsLastItem: false,
    MobileIcon: "ActivitiesMobile",
    Nodes: [
      {
        Name: "Submenu 1",
        Route: "/Sub1",
      },
      {
        Name: "Submenu 2",
        Route: "/Sub2",
      },
    ],
  },
  {
    Name: "Skill Database",
    Route: "/skillDatabase",
    IsExact: false,
    ClassName: "nav-parent",
    IsLastItem: false,
    MobileIcon: "SkillMobile",
    Nodes: [
      {
        Name: "Submenu 1",
        Route: "/Sub1",
      },
      {
        Name: "Submenu 2",
        Route: "/Sub2",
      },
    ],
  },
  {
    Name: "Trainings",
    Route: "/trainings",
    IsExact: false,
    ClassName: "nav-parent",
    IsLastItem: true,
    MobileIcon: "TrainingsMobile",
    Nodes: [
      {
        Name: "Submenu 1",
        Route: "/Sub1",
      },
      {
        Name: "Submenu 2",
        Route: "/Sub2",
      },
    ],
  },
  {
    Name: "AI",
    Route: "/ai",
    IsExact: false,
    ClassName: "nav-parent is-desktop",
    IsLastItem: false,
    Nodes: [
      {
        Name: "Submenu 1",
        Route: "/Sub1",
      },
      {
        Name: "Submenu 2",
        Route: "/Sub2",
      },
    ],
  },
  {
    Name: "Workflows",
    Route: "/workflows",
    IsExact: false,
    ClassName: "nav-parent is-desktop",
    IsLastItem: false,
    Nodes: [
      {
        Name: "Submenu 1",
        Route: "/Sub1",
      },
      {
        Name: "Submenu 2",
        Route: "/Sub2",
      },
    ],
  },
  {
    Name: "Communication",
    Route: "/communication",
    IsExact: false,
    ClassName: "nav-parent",
    IsLastItem: true,
    MobileIcon: "CommunicationMobile",
    Nodes: [
      {
        Name: "Submenu 1",
        Route: "/Sub1",
      },
      {
        Name: "Submenu 2",
        Route: "/Sub2",
      },
    ],
  },
  {
    Name: "Code tables",
    Route: "/codeTables",
    IsExact: false,
    ClassName: "nav-parent is-desktop",
    IsLastItem: false,
    Nodes: [
      {
        Name: "Submenu 1",
        Route: "/Sub1",
      },
      {
        Name: "Submenu 2",
        Route: "/Sub2",
      },
    ],
  },
  {
    Name: "Security Settings",
    Route: "/securitySettings",
    IsExact: false,
    ClassName: "nav-parent is-desktop",
    IsLastItem: false,
    Nodes: [
      {
        Name: "User Management",
        Route: "/userManagement",
      },
      {
        Name: "Security Profiles",
        Route: "/securityProfiles",
      },
      {
        Name: "ACLs",
        Route: "/ACLs",
      },
    ],
  },
  {
    Name: "System Settings",
    Route: "/systemSettings",
    IsExact: false,
    ClassName: "nav-parent is-desktop",
    IsLastItem: false,
    Nodes: [
      {
        Name: "Submenu 1",
        Route: "/Sub1",
      },
      {
        Name: "Submenu 2",
        Route: "/Sub2",
      },
    ],
  },
  {
    Name: "Connections",
    Route: "/connections",
    IsExact: false,
    ClassName: "nav-parent is-desktop",
    IsLastItem: false,
    Nodes: [
      {
        Name: "Submenu 1",
        Route: "/Sub1",
      },
      {
        Name: "Submenu 2",
        Route: "/Sub2",
      },
    ],
  },
  {
    Name: "Invoiceses",
    Route: "/invoiceses",
    IsExact: false,
    ClassName: "nav-parent is-desktop",
    IsLastItem: false,
    Nodes: [
      {
        Name: "Submenu 1",
        Route: "/Sub1",
      },
      {
        Name: "Submenu 2",
        Route: "/Sub2",
      },
    ],
  },
];

export const Bookmarks = [
  {
    Image: "Home",
    Route: "/",
    IsExact: true,
    ClassName: "nav-bookmark",
    ActiveClassName: "nav-active",
    id: "home-bookmark",
    TooltipText: "Home",
  },

  // {
  //   Image: "SimilarPeople",
  //   Route: "/similarPeople",
  //   IsExact: false,
  //   ClassName: "nav-bookmark",
  //   ActiveClassName: "nav-active",
  // },
  // {
  //   Image: "RecommendedSkills",
  //   Route: "/recommendedSkills",
  //   IsExact: false,
  //   ClassName: "nav-bookmark",
  //   ActiveClassName: "nav-active",
  // },
  {
    Image: "Communication",
    Route: "/communication",
    IsExact: false,
    ClassName: "nav-bookmark",
    ActiveClassName: "nav-active",
    id: "icp-bookmark",
    TooltipText: "Conversations"
  },
  {
    Image: "Dashboard",
    Route: "/employeeDashboard",
    IsExact: true,
    ClassName: "nav-bookmark",
    ActiveClassName: "nav-active",
    id: "dashboard-bookmark",
    TooltipText: "Dashboard"
  },
  // {
  //   Image: "JPA",
  //   Route: "/JPA",
  //   IsExact: false,
  //   ClassName: "nav-bookmark",
  //   ActiveClassName: "nav-active",
  // },
  {
    Image: "Logout",
    Route: "/trainAI",
    IsExact: false,
    ClassName: "nav-bookmark is-mobile",
    ActiveClassName: "",
    id: "logout-mobile-bookmark",
  },
];
